import { create } from 'zustand'

interface PremiumModalSettings {
  message?: string
}

interface PremiumModalState {
  isOpen: boolean
  settings: PremiumModalSettings
  openModal: (settings?: PremiumModalSettings) => void
  closeModal: () => void
}

export const usePremiumModalStore = create<PremiumModalState>((set) => ({
  isOpen: false,
  settings: {},
  openModal: (settings) => set({ isOpen: true, settings: settings || {} }),
  closeModal: () => set({ isOpen: false, settings: {} }),
}))
